import { atomWithStorage } from 'jotai/utils';

export const pinsAtom = atomWithStorage('pins', []);
